module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-solid-900.woff2?43df9d1bc2c86cd9a2c5e7ee4937a45b";